import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg height={height} width={width} {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7332 12.2666C12.563 12.5495 13.0666 12.9212 13.0666 13.3283C13.0666 14.2147 10.6788 14.9333 7.73324 14.9333C4.78772 14.9333 2.3999 14.2147 2.3999 13.3283C2.3999 12.9212 2.90342 12.5495 3.73324 12.2666" stroke="#72808F" strokeLinecap="round" />
      <path d="M9.73315 6.6001C9.73315 7.7047 8.83775 8.6001 7.73315 8.6001C6.62855 8.6001 5.73315 7.7047 5.73315 6.6001C5.73315 5.49553 6.62855 4.6001 7.73315 4.6001C8.83775 4.6001 9.73315 5.49553 9.73315 6.6001Z" stroke="#72808F" />
      <path d="M7.73315 1.6001C10.439 1.6001 12.7332 3.88545 12.7332 6.65803C12.7332 9.47476 10.4017 11.4514 8.24815 12.7956C8.09122 12.8859 7.91375 12.9334 7.73315 12.9334C7.55255 12.9334 7.37509 12.8859 7.21815 12.7956C5.06865 11.4383 2.73315 9.4845 2.73315 6.65803C2.73315 3.88545 5.02729 1.6001 7.73315 1.6001Z" stroke="#72808F" />
    </svg>

  )
}

export default SvgComponent
